import React, { useEffect, useState } from "react";
import { faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, CardBody, CardHeader, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5";
import "datatables.net-responsive-dt";
import { useApiStore } from "../../hooks/ApiStoreContext";
import Swal from "sweetalert2";

const Banner = () => {
  const apiStore = useApiStore();
  DataTable.use(DT);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    getBannerList();
  }, []);

  const getBannerList = async () => {
    try {
      const response = await apiStore.get("/banners");
      setTableData(response);
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("There was an error fetching banners!", error);
      }
    }
  };

  const handleAdd = (e) => {
    e.preventDefault();
    navigate("/add-banner");
  };

  const handleEdit = (e, id) => {
    e.preventDefault();
    navigate("/add-banner/" + id);
  };

  const handleDelete = async (e, id) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        await apiStore.delete(`/banners/${id}`);
        await Swal.fire("Deleted!", "Banner deleted successfully.", "success");
        getBannerList(); // Refresh the page
      } catch (error) {
        if (error.response.status !== 401) {
          console.error("There was an error deleting the banner!", error);
          Swal.fire("Error!", "There was an error deleting the banner.", "error");
        }
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire("Cancelled", "Your banner is safe :)", "error");
    }
  };

  const handleStatus = async (e, data, row) => {
    try {
      const submitData = {
        bannerId: row.bannerId,
        name: row.name,
        description: row.description,
        link: row.link,
        imageSource: row.imageSource,
        displaySequence: row.displaySequence,
        isActive: !data,
        createdDate: row.createdDate,
      };
      await apiStore.put(`/banners/${row.bannerId}`, submitData);
      getBannerList();
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("There was an error updating the banner status!", error);
      }
    }
  };

  return (
    <Row>
      <Col md={12}>
        <Card className="mb-4">
          <CardHeader className="pb-0">
            <Row>
              <Col md={9}>
                <h4>Banner List</h4>
              </Col>
              <Col md={3} className="d-grid d-md-flex justify-content-md-end d-sm-block">
                <Button variant="outline-primary" className="btn-sm" onClick={handleAdd}>
                  Add Banner
                </Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody className="px-0 pt-0 pb-2">
            <div className="mx-3">
              <DataTable
                className="display table align-items-center mb-0 p-0"
                data={tableData}
                options={{
                  responsive: true,
                  columns: [
                    { data: "name", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "description", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "link", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "imageSource", className: "text-secondary text-sm font-weight-bold align-middle", visible: false },
                    { data: "displaySequence", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "isActive", className: "text-sm font-weight-bold align-middle text-center" },
                    { data: "bannerId", className: "text-secondary text-sm font-weight-bold align-middle text-center" },
                  ],
                  order: [[4, "asc"]],
                }}
                slots={{
                  5: (data, row) => {
                    return (
                      <React.Fragment>
                        <span className={data ? "badge badge-sm cursor-pointer bg-gradient-success" : "badge badge-sm cursor-pointer bg-gradient-danger"} onClick={(e) => handleStatus(e, data, row)}>
                          {data ? "Active" : "Inactive"}
                        </span>
                      </React.Fragment>
                    );
                  },
                  6: (data, row) => {
                    return (
                      <React.Fragment>
                        <a className="me-3 cursor-pointer" title="Edit" onClick={(e) => handleEdit(e, data)}>
                          <FontAwesomeIcon icon={faPencil} size="lg"></FontAwesomeIcon>
                        </a>
                        <a className="text-danger cursor-pointer" title="Delete" onClick={(e) => handleDelete(e, data)}>
                          <FontAwesomeIcon icon={faTrashCan} size="lg"></FontAwesomeIcon>
                        </a>
                      </React.Fragment>
                    );
                  },
                }}>
                <thead>
                  <tr>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Name</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Description</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Link</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Image Source</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Order</th>
                    <th className="text-center text-uppercase text-secondary text-sm font-weight-bolder">Is Active</th>
                    <th className="text-center text-uppercase text-secondary text-sm font-weight-bolder">Action</th>
                  </tr>
                </thead>
              </DataTable>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default Banner;
